// Shared 30-day free-trial state for BI & Reporting (per tenant, client-side).
export const TRIAL_DAYS = 30;
const DAY = 24 * 60 * 60 * 1000;

export const trialKey = (tenantId) => `crediarc_bi_trial_${tenantId || "default"}`;

export const readTrial = (tenantId) => {
  try { return JSON.parse(localStorage.getItem(trialKey(tenantId)) || "null"); } catch { return null; }
};

export const writeTrial = (tenantId, record) => {
  try { localStorage.setItem(trialKey(tenantId), JSON.stringify(record)); } catch { /* ignore */ }
};

export const acceptTrial = (tenantId) => {
  const record = { status: "accepted", startedAt: Date.now() };
  writeTrial(tenantId, record);
  return record;
};

export const deferTrial = (tenantId) => {
  const record = { status: "later", seenAt: Date.now() };
  writeTrial(tenantId, record);
  return record;
};

export const trialDaysLeft = (record) =>
  record?.startedAt ? Math.max(0, TRIAL_DAYS - Math.floor((Date.now() - record.startedAt) / DAY)) : null;

export const isTrialActive = (record) => {
  const left = trialDaysLeft(record);
  return record?.status === "accepted" && left > 0;
};

// Whether the user has made a first-entry decision yet (accept or "maybe later").
export const hasDecidedTrial = (tenantId) => {
  const r = readTrial(tenantId);
  return !!r && (r.status === "accepted" || r.status === "later");
};
